import React from 'react';
import axios from 'axios';
import qs from 'qs';
import { translations } from './translations';
import './App.scss';
import MemberList from './components/MemberList';
import SearchBar from './components/SearchBar';
import Modal from './components/Modal';

const controller = new AbortController();
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      error: null,
      members: [],
      page: 1,
      selectedResource: null,
      instructorsOnly:  window?.memberSearchConfig?.instructorOnly || false,
      wing_type: 'both',
      province: undefined,
      recordCount: 0,
      lang: window?.memberSearchConfig?.lang || 'en',
      showFilters: false,
      activeMembersOnly: true,
      has_hagar: false,
    };

    this.strings = this.state.lang === 'en' ? translations.en : translations.fr;
    this.handleInstructorToggle = this.handleInstructorToggle.bind(this);
    this.handleActiveMembersToggle = this.handleActiveMembersToggle.bind(this);
    this.handleHasHAGARToggle = this.handleHasHAGARToggle.bind(this);
    this.handleProvinceSelect = this.handleProvinceSelect.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.provinces = this.state.lang === 'en' ? translations.en.provinces : translations.fr.provinces;
  }

  fetchMember(params = {}) {
    let endpoint = window?.memberSearchConfig?.endpoint || 'http://localhost:3000';
    let url = `${endpoint}/api/v1/members/${params.member_number}`;

    axios.get(url, {
      ID: params.query
    })
    .then(res => {
      this.setState({
        selectedResource: res.data[0],
        member_details: res.data[0],
        isLoading: false
      });
    })
    .catch(error => this.setState({ error, isLoading: false }));
  }

  fetchResource(params = {}) {
    this.setState({
      members: [],
      isLoading: true,
      recordCount: 0,
    });

    let endpoint = window?.memberSearchConfig?.endpoint || 'http://localhost:3000';
    let url = (this.state.instructorsOnly) ? `${endpoint}/api/v1/instructors` : `${endpoint}/api/v1/members`;

    controller.abort()

    axios.get(url, {
      params: {
        query: this.state.query,
        page: this.state.page,
        user: {
          province: this.state.province ? this.state.province : null,
          has_hagar:  this.state.has_hagar,
        },
        wing_type: this.state.wing_type,
        activeMembersOnly: this.state.activeMembersOnly,
      },
      paramsSerializer: function (params) {
        return qs.stringify(params, {arrayFormat: 'brackets'})
      }
    })
    .then(res => {
      this.setState({
        members: res.data,
        isLoading: false,
        recordCount: parseInt(res.headers.recordcount),
        totalPages: parseInt(res.headers.pages)
      });
    })
    .catch(error => this.setState({ error, isLoading: false }));
  }

  updateQuery = (query) => {
    this.setState({ query: query });
    this.fetchResource({query: this.state.query});
  };

  showFilters = () =>{
    this.setState({ showFilters: !this.state.showFilters });
  }

  selectedResource = (resource) => {
    this.setState({ selectedResource: resource });
  }

  nextPage = () => {
    window.scrollTo(0, 0);
    this.setState({
      page: this.state.page + 1
    })
  }

  prevPage = () => {
    window.scrollTo(0, 0);
    this.setState({
      page: this.state.page > 1 ? this.state.page - 1 : 1
    })
  }

  close = () => {
    this.setState({ selectedResource: null });
  }

  componentDidMount() {
    const hasMember = window.location.search;
    if(hasMember) {
      this.fetchMember({query: hasMember.replace('?', ''), member_number: hasMember.replace('?', '')})
    }
    this.fetchResource();
  }

  handleInstructorToggle(event){
    this.setState({instructorsOnly: event.target.checked});
  }

  handleActiveMembersToggle(event, triggerUpdate = false){
    this.setState({activeMembersOnly: event.target.checked, query: triggerUpdate ? '' : this.state.query});
    if(triggerUpdate) {
      // This is a hacky solution to make sure the input value is cleared
      const searchInput = document.querySelector('.search > input');
      searchInput.value = '';
    }
  }

  handleHasHAGARToggle(event, triggerUpdate = false){
    this.setState({has_hagar: event.target.checked, query: triggerUpdate ? '' : this.state.query});
    if(triggerUpdate) {
      // This is a hacky solution to make sure the input value is cleared
      const searchInput = document.querySelector('.search > input');
      searchInput.value = '';
    }
  }

  handleProvinceSelect(event){
    this.setState({province: event.target.value});
  }

  onChangeValue(event) {
    this.setState({
      wing_type: event.target.value
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevState.page !== this.state.page ) {
      this.fetchResource();
    }

    if(prevState.instructorsOnly !== this.state.instructorsOnly ) {
      this.setState({ page: 1 });
      this.fetchResource({});
    }

    if(prevState.activeMembersOnly !== this.state.activeMembersOnly ) {
      this.setState({ page: 1 });
      this.fetchResource({});
    }


    if(prevState.has_hagar !== this.state.has_hagar ) {
      this.setState({ page: 1 });
      this.fetchResource({});
    }

    if(prevState.wing_type !== this.state.wing_type ) {
      this.setState({ page: 1 });
      this.fetchResource({});
    }

    if(prevState.province !== this.state.province ) {
      this.setState({ page: 1 });
      this.fetchResource({});
    }
  }

  componentWillUnmount() {
  }

  render() {

    let modal, instructorsToggle;

    if (this.state.selectedResource) {
      modal = <Modal selectedResource={this.state.selectedResource} close={this.close} />
    } else {
      modal = null;
    }

    if(!window?.memberSearchConfig?.instructorOnly){
      instructorsToggle = <label>
                            <input type="checkbox" value={this.state.instructorsOnly} onChange={this.handleInstructorToggle} />
                            {`${this.strings.filter_instructors_only}`}
                          </label>;
    } else {
      instructorsToggle = null;
    }

    return (
      <div className="App">
        {modal}
        <SearchBar strings={this.strings} query={this.state.query} updateQuery={this.updateQuery} showFilters={this.showFilters}/>
        <div className="filters-container">
          {this.state.showFilters && (
              <div className="filters">
                <div className="filters-col">
                  {instructorsToggle}
                  <label>
                    <input type="checkbox" value={this.state.activeMembersOnly} checked={this.state.activeMembersOnly} onChange={this.handleActiveMembersToggle} />
                    {`${this.strings.filter_active_members_only}`}
                  </label>
                  <label>
                    <input type="checkbox" value={this.state.has_hagar} checked={this.state.has_hagar} onChange={this.handleHasHAGARToggle} />
                    {`${this.strings.has_hagar}`}
                  </label>
                </div>
                <div className="filters-col" onChange={this.onChangeValue}>
                  <label>Wing type:</label>
                  <div  className="filters-option-grp">
                    <input id="both" type="radio" name="wing_type" value="both" defaultChecked={this.state.wing_type === "both"} />
                    <label htmlFor="both">{`${this.strings.wing_types.both}`}</label>
                  </div>
                  <div  className="filters-option-grp">
                    <input id="pg" type="radio" name="wing_type" value="pg" defaultChecked={this.state.wing_type === "pg"} />
                    <label htmlFor="pg">{`${this.strings.wing_types.pg}`}</label>
                  </div>
                  <div  className="filters-option-grp">
                    <input id="hg" type="radio" name="wing_type" value="hg" defaultChecked={this.state.wing_type === "hg"} />
                    <label htmlFor="hg">{`${this.strings.wing_types.hg}`}</label>
                  </div>
                </div>
                <div  className="filters-col">
                  <select value={this.state.province} onChange={this.handleProvinceSelect}>
                    <option value="">{`${this.strings.filter_by_province}`}</option>
                    {Object.keys(this.provinces).map(province => <option value={province} key={province}>{this.provinces[province]}</option>)}
                  </select>
                </div>
              </div>
          )}

        </div>
        <p className="list-result-total" >{`${this.state.recordCount.toLocaleString()} ${this.strings.members_found}`}</p>
        <MemberList strings={this.strings} members={this.state.members} isLoading={this.state.isLoading} selectedResource={this.selectedResource} handleActiveMembersToggle={this.handleActiveMembersToggle}/>
        <div className="list-navigation">
          <button onClick={this.prevPage} disabled={this.state.page === 1}>
            <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5.95 10.36">
              <path d="M5.39,10.29a.25.25,0,0,1-.19.07A.31.31,0,0,1,5,10.29L.09,5.37A.25.25,0,0,1,.09,5L5,.07A.31.31,0,0,1,5.2,0a.25.25,0,0,1,.19.07l.47.47A.23.23,0,0,1,6,.73a.3.3,0,0,1-.09.21L1.62,5.18,5.86,9.42A.29.29,0,0,1,6,9.63a.23.23,0,0,1-.09.19Z"/>
            </svg>
            {`${this.strings.prev}`}
          </button>
          <button onClick={this.nextPage} disabled={this.state.members.length < 50 || this.state.totalPages < this.state.page}>
            {`${this.strings.next}`}
            <svg className="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 5.95 10.36">
              <path d="M.56.07A.25.25,0,0,1,.75,0,.31.31,0,0,1,1,.07L5.86,5a.25.25,0,0,1,0,.38L1,10.29a.31.31,0,0,1-.21.07.25.25,0,0,1-.19-.07L.09,9.82A.23.23,0,0,1,0,9.63a.29.29,0,0,1,.09-.21L4.34,5.18.09.94A.3.3,0,0,1,0,.73.23.23,0,0,1,.09.54Z"/>
            </svg>
          </button>
        </div>
      </div>
    );
  }
}

export default App;
